import React, { BaseSyntheticEvent, useEffect, useState } from 'react';
import Page from 'src/layout/Page';
import './myTimesheet.css';
import { useNavigate } from 'react-router-dom';
import useChildren from 'src/hooks';
import CloseIcon from 'components/CloseIcon/CloseIcon';
import useBookedLessons from 'src/hooks/useBookedLessons';
import useDelete from 'src/hooks/useDelete';
import { useTranslation } from 'react-i18next';

const MyTimesheet: React.FC = (): React.ReactElement => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [childId, setChildId] = useState<number | undefined>(undefined);
  const [reFetchLessons, setReFetchLessons] = useState<boolean>(false);
  const navigate = useNavigate();
  const { children } = useChildren();
  const { bookedLessons } = useBookedLessons({ lessonType: 'all', reFetch: reFetchLessons });
  const { makeDeleteRequest } = useDelete();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.title = t('pages.myTimesheet.title') as string;
  }, [i18n.language]);

  useEffect(() => {
    if (children && children.length) {
      setChildId(children[0].id);
    }
  }, [children?.length]);

  const handleActiveChildren = (e: BaseSyntheticEvent, index: number, id: number) => {
    e.preventDefault();
    setActiveIndex(index);
    setChildId(id);
  };

  const handleBookMore = (e: BaseSyntheticEvent) => {
    e.preventDefault();
		if (i18n.language !== 'en') {
			navigate('/תיאום', { state: { childId } });
		} else {
			navigate('/en/booking', { state: { childId } });
		}

  };

  const handleDeleteLesson = async (e: BaseSyntheticEvent, lessonBookingId: number) => {
    e.preventDefault();
    const response = await makeDeleteRequest(`lessons-booking/${lessonBookingId}`);
    if (response?.status === 200) {
      setReFetchLessons(!reFetchLessons);
    }
  };

  return <Page pageClass={'timesheet-page'}>
    <div className="content-wrapper">
      <div className={'children-container'}>
        {children?.map((child: any, index: number) => (
          <div className={`child ${activeIndex === index ? 'active' : ''}`} key={child.id}
               onClick={(e) => handleActiveChildren(e, index, child.id)}>
            {child.lastname} {child.firstname}
          </div>
        ))}
      </div>
      <div className="lessons-schedule-container">
        {bookedLessons.filter((l) => l.childId === childId).map((bookedLesson, index) => (
          <div key={`booked-lesson-${index}`} className={'booked-lesson'}>
            <div className={`lesson-container ${new Date(bookedLesson.bookingDate) > new Date() ? 'can-be-deleted' : ''}`}>
              <div className="lesson-info">
                {`${bookedLesson.lessonName} [${bookedLesson.firstName} ${bookedLesson.lastName}] ${bookedLesson.bookingDate}`}
              </div>
              {
                new Date(bookedLesson.bookingDate) > new Date()
                && <span className={'delete-button'} title={'Cancel lesson'} onClick={(e) => handleDeleteLesson(e, bookedLesson.lessonBookingId)}><CloseIcon
                  color={'white'} width={12} height={12}/></span>
              }
            </div>
          </div>
        ))}
      </div>
      <div className="book-more-container">
        <button className={'active'} onClick={handleBookMore}>{t('pages.myTimesheet.bookMore')}</button>
      </div>
    </div>
  </Page>;
};

export default MyTimesheet;
